import EmitenteTipoUsuarioService from "@/services/EmitenteTipoUsuarioService";

export const emitenteTipoUsuario = {
  namespaced: true,
  state: {
    emitenteTipoUsuario: {},
  },
  actions: {
    getEmitenteTipoUsuario({ commit }, payload) {
      return EmitenteTipoUsuarioService.GetEmitenteTipoUsuario(payload).then(
        (emitenteTipoUsuario) => {
          return Promise.resolve(emitenteTipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitenteTipoUsuario({ commit }, payload) {
      return EmitenteTipoUsuarioService.PostEmitenteTipoUsuario(payload).then(
        (emitenteTipoUsuario) => {
          return Promise.resolve(emitenteTipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitenteTipoUsuario({ commit }, payload) {
      return EmitenteTipoUsuarioService.PutEmitenteTipoUsuario(payload).then(
        (emitenteTipoUsuario) => {
          return Promise.resolve(emitenteTipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEmitenteTipoUsuario({ commit }, payload) {
      return EmitenteTipoUsuarioService.DeleteEmitenteTipoUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteTipoUsuarioOData({ commit }, payload) {
      return EmitenteTipoUsuarioService.GetEmitenteTipoUsuarioOData(
        payload
      ).then(
        (emitenteTipoUsuario) => {
          return Promise.resolve(emitenteTipoUsuario);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default emitenteTipoUsuario;
